import { IClaioImageSource } from "../../domain/claio";

export interface IClaioImageStockable {
  getStockedClaioImage(patientId: string, claioImageId: string): IClaioImageSource;
}

export function instanceOfIClaioImageStockable(instance: any): instance is IClaioImageStockable {
  return instance
    && (instance.getStockedClaioImage !== undefined);
}
